/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Password_Min_HintInputs */

const vi_user_password_min_hint = /** @type {(inputs: User_Password_Min_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tối thiểu 8 ký tự`)
};

/**

* @param {User_Password_Min_HintInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const user_password_min_hint = /** @type {((inputs?: User_Password_Min_HintInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Password_Min_HintInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_user_password_min_hint(inputs)
});